function getFrozenRowsBorderColor(args) {
    const {row: row, table: {frozenRowCount: frozenRowCount}} = args;
    return frozenRowCount - 1 === row ? [ "#f2f2f2", "#f2f2f2", "#ccc7c7", "#f2f2f2" ] : [ "#f2f2f2" ];
}

function getBorderColor(args) {
    const {col: col, table: table} = args, {colCount: colCount, frozenColCount: frozenColCount} = table, top = "#ccc7c7";
    return frozenColCount - 1 === col || colCount - 1 === col ? [ top, "#f2f2f2", "#ccc7c7", null ] : [ top, null, "#ccc7c7", null ];
}

export default {
    name: "SIMPLIFY",
    underlayBackgroundColor: "#FFF",
    defaultStyle: {
        borderColor: getBorderColor,
        hover: {
            cellBorderColor: "#0000FF",
            cellBgColor: "#D0E0E3"
        },
        bgColor: "#FFF"
    },
    headerStyle: {
        color: "rgba(0, 0, 0, 0.87)",
        borderColor: getFrozenRowsBorderColor
    },
    bodyStyle: {
        color: "rgba(0, 0, 0, 0.87)"
    },
    frameStyle: {
        borderColor: "#f2f2f2",
        borderLineWidth: 1
    },
    columnResize: {
        lineWidth: 1,
        lineColor: "#416EFF",
        bgColor: "#D9E2FF"
    },
    selectionStyle: {
        cellBorderColor: "#FD5",
        cellBgColor: "rgba(111, 168, 220, 0.1)"
    },
    tooltipStyle: {
        bgColor: "#FFF",
        color: "#000",
        fontSize: 12,
        fontFamily: "Arial,sans-serif"
    }
};
//# sourceMappingURL=SIMPLIFY.js.map
